import './App.scss';
import { Outlet } from "react-router";
import NavBar from './components/navbar';
import Footer from "./components/footer";


function App() {

  return (
    <>
      <NavBar/>
      <main>
        <Outlet />
      </main>
      <Footer/>
    </>
  )

}

export default App;